module.exports = __webpack_public_path__ + "themes/mf/img/prize-tmp@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-tmp@2x.png
// module id = 105
// module chunks = 3